export interface Volume {
  code: string
  name: string
  count: string
  /** Spine color from the product mockup. */
  color: string
  intro: string
  highlights: string[]
  result: string
}

export const volumes: Volume[] = [
  {
    code: '1',
    name: 'Foundations & Ready-to-Run Sessions',
    count: '12 sessions',
    color: '#2563eb',
    intro:
      'Movement, ball control, passing, receiving, shooting and first decisions.',
    highlights: [
      'Ready position & balance',
      'Overarm passing',
      'Basic shooting',
      'First 2v1 decisions',
    ],
    result:
      'A clear technical foundation that connects skill to game situations.',
  },
  {
    code: '2',
    name: 'Passing, Receiving & Shooting',
    count: '12 sessions',
    color: '#0d9488',
    intro: 'Cleaner ball circulation and more effective finishing.',
    highlights: [
      'Passing on the move',
      'Reception timing',
      'Shooting mechanics',
      'Pass-to-shot combos',
    ],
    result: 'Players pass, receive and finish with control, timing and purpose.',
  },
  {
    code: '3',
    name: '1v1, Movement & Creating Space',
    count: '12 sessions',
    color: '#ea580c',
    intro: 'Attack space, beat defenders and support the ball.',
    highlights: [
      '1v1 & simple feints',
      'Off-ball movement',
      'Passing lanes',
      'Reading defenders',
    ],
    result: 'Players create advantages instead of waiting for them.',
  },
  {
    code: '4',
    name: 'Defense & Goalkeeping',
    count: '12 sessions',
    color: '#dc2626',
    intro: 'Stronger defending, better positioning and goalkeeper foundations.',
    highlights: [
      'Defensive footwork',
      '1v1 defending',
      'Helping teammates',
      'Goalkeeper positioning',
    ],
    result: 'Clearer roles, better positioning and coordinated responses.',
  },
  {
    code: '5',
    name: 'Team Play & Game Situations',
    count: '12 sessions',
    color: '#7c3aed',
    intro: 'Turn individual skills into collective handball.',
    highlights: [
      '2v1 · 2v2 · 3v2 · 3v3',
      'Numerical advantages',
      'Transition principles',
      'Small-sided games',
    ],
    result: 'Players read situations and make better collective decisions.',
  },
  {
    code: '6',
    name: 'Planning & Team Organization',
    count: '12 sessions',
    color: '#64748b',
    intro: 'Turn exercises into a complete coaching structure.',
    highlights: ['Drills', 'Sessions', 'Weeks', 'Training blocks', 'Season priorities'],
    result: 'A repeatable system instead of improvising every week.',
  },
]
